export const UUID = 'uuid'
export const TOKEN = 'token'
export const SHOP_ID = 'shop_id'